export const DATA_LIMIT = 25;

export const PINTEREST_BOARD_FIELDS_LIST: any = [
    {
        attribute: "image_cover_url",
        label: "Cover Image",
        cssClass: 'w-24 text-center',
        isImage: true,
        parent: 'media',
    },
    {attribute: "name", label: "Name", cssClass: ''},
    {attribute: "description", label: "Description", cssClass: '', secondaryAttributes: ['privacy', 'id']},
    {attribute: "pin_count", label: "Pin Count", cssClass: 'text-center'},
    {attribute: "collaborator_count", label: "Collaborator Count", cssClass: 'text-center'},
    {attribute: "follower_count", label: "Follower Count", cssClass: 'text-center'},
    {attribute: "created_at", label: "Created At", cssClass: 'text-center'},
];


export const PINTEREST_BOARD_INPUT_FIELDS: any = [
    {attribute: "name", label: "Name", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "description", label: "Description", type: 'text-area', rows: '3', group: 'detail', cssClass: ''},
    {
        attribute: "privacy",
        label: "Privacy",
        type: 'select',
        group: 'detail',
        cssClass: '',
        options: [
            {label: 'PUBLIC', value: 'PUBLIC'},
            {label: 'PROTECTED', value: 'PROTECTED'},
            {label: 'SECRET', value: 'SECRET'}]
    },
];
